import React from "react"
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import {Box} from "@mui/material";
import {MAIN_COLOR_RED} from "../../assets/styles";
import logo from "../../assets/img/logo-white.png"


const Navbar = () => {
    return(
        <AppBar position="static" sx={{ backgroundColor: MAIN_COLOR_RED }}>
            <Toolbar sx={{ justifyContent: "flex-end" }}>
                <Box component="img" src={logo} alt="Logo" sx={{ height: 36 }} />
            </Toolbar>
        </AppBar>

    )
}
export default Navbar